import { api } from "@/lib/api/client";
import type {
  TaskDetail,
  TaskListQuery,
  TaskListResponse,
  TaskSummary,
  WorkRequestListResponse,
  WorkTaskListResponse,
} from "@pkhoffice/shared";

export async function fetchTasks(q: Partial<TaskListQuery>): Promise<TaskListResponse> {
  const { data } = await api.get("/task/list", { params: q });
  return data.data ?? data;
}

export async function fetchTask(id: number): Promise<TaskDetail> {
  const { data } = await api.get(`/task/${id}`);
  return data.data ?? data;
}

export async function fetchMyTasks(): Promise<TaskSummary[]> {
  const { data } = await api.get("/task/my");
  return data.data ?? data;
}

export async function createTask(payload: Record<string, unknown>): Promise<TaskDetail> {
  const { data } = await api.post("/task", payload);
  return data.data ?? data;
}

export async function updateTask(
  id: number,
  payload: Record<string, unknown>,
): Promise<TaskDetail> {
  const { data } = await api.put(`/task/${id}`, payload);
  return data.data ?? data;
}

export async function deleteTask(id: number): Promise<void> {
  await api.delete(`/task/${id}`);
}

export async function completeTask(id: number, percent = 100, completed = true): Promise<void> {
  await api.post(`/task/${id}/complete`, { percent, completed });
}

export async function fetchWorkRequests(
  q?: Record<string, string | number | undefined>,
): Promise<WorkRequestListResponse> {
  const { data } = await api.get("/task/requests", { params: q });
  return data.data ?? data;
}

export async function fetchWorkSummary(
  q?: Record<string, string | number | undefined>,
): Promise<WorkTaskListResponse> {
  const { data } = await api.get("/task/summary", { params: q });
  return data.data ?? data;
}

export async function fetchWorkDept(
  q?: Record<string, string | number | undefined>,
): Promise<WorkTaskListResponse> {
  const { data } = await api.get("/task/dept", { params: q });
  return data.data ?? data;
}
